import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { DataGridPremium, GridToolbar } from '@mui/x-data-grid-premium';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';

/** Material UI Icons. */
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

/** Redux Packages. */
import { useDispatch } from 'react-redux';

/** Redux Reducers. */
import { setSnackbar } from '../../state/slices/snackBarSlice';

/** Internal Components. */
import { callAPI } from '../../api/useApiRequest';

export default function DeletedTable(props) {
    /** Get props from Account.js. */
    const { delRow, setDelRow, email } = props;

    const dispatch = useDispatch();

    /** Datagrid Row delete handler for deleted account info.  */
    const handleDeleteClick = (id) => () => {
        if (window.confirm('Are you sure you want to delete the account?')) {
            const del_info = delRow.filter((row) => row.id == id).map(({ id, ref_id }) => ({ id, ref_id }));
            //     /** POST request to DB */
            //     apiRequest('accounts', 'deleted', email, del_info)
            //         .then((response) => {
            //             if (response.data['body-json'].statusCode === 200) {
            //                 setSnackbar({
            //                     open: true,
            //                     message: response.data['body-json'].body.message,
            //                     severity: 'success',
            //                 });
            //                 setDelRow(delRow.filter((row) => row.id !== id));
            //             } else {
            //                 setSnackbar({
            //                     open: true,
            //                     message: response.data['body-json'].body.message,
            //                     severity: 'error',
            //                 });
            //             }
            //         })
            //         .catch((error) => {
            //             setSnackbar({
            //                 open: true,
            //                 message: 'Something went wrong. Please try again.',
            //                 severity: 'error',
            //             });
            //         });
            callAPI({
                method: 'post',
                module: 'accounts',
                component: 'deleted',
                email: email,
                obj: del_info,
                onSuccess: (resp) => {
                    setDelRow(delRow.filter((row) => row.id !== id));
                    dispatch(
                        setSnackbar({
                            open: true,
                            message: 'Account has been successfully deleted.',
                            severity: 'success',
                        }),
                    );
                },
                onError: () => {
                    dispatch(
                        setSnackbar({
                            open: true,
                            message: 'Something went wrong. Please try again.',
                            severity: 'error',
                        }),
                    );
                },
            });
        }
    };

    /** Define Deleted account info Datagrid Fields. */
    const del_col = [
        { field: 'id', headerName: 'ID', align: 'center', headerAlign: 'center', flex: 0.2, hide: true },
        {
            field: 'ref_id',
            headerName: 'Ref Id',
            flex: 0.2,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'name',
            headerName: 'Account Name',
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'email',
            headerName: 'User Email',
            flex: 2,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            flex: 0.2,
            cellClassName: 'actions',
            align: 'center',
            headerAlign: 'center',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];
    return (
        <>
            <DataGridPremium
                rows={delRow}
                columns={del_col}
                density="compact"
                disableRowSelectionOnClick
                unstable_cellSelection
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                    pagination: { paginationModel: { pageSize: 25 } },
                }}
                pagination={true}
                pageSizeOptions={[25, 50, 100]}
                sx={{ fontSize: 13, height: '82vh', border: 'none' }}
            />
        </>
    );
}
